// extracted by mini-css-extract-plugin
export default {"causesList":"CausesList_causesList__ypyqg","listItem":"CausesList_listItem__4N9D6"};